var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_414_8918)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3331 8.31819C32.4171 8.20616 32.5385 8.0848 32.6785 8.11747C32.7299 8.13148 32.7719 8.15948 32.7999 8.20149C32.8606 8.27618 32.9353 8.93901 32.9353 9.03703C32.9446 9.5505 32.8652 9.93326 32.8139 10.05C32.7625 10.1666 32.6739 10.2693 32.5525 10.3114C32.3191 10.386 32.0764 10.19 31.983 9.96593C31.8757 9.71854 31.815 9.41046 31.9083 9.15373C32.0157 8.85966 32.1464 8.57959 32.3331 8.32286V8.31819Z",
    fill: "#1F8FD3"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M32.7773 8.17815C32.7493 8.15015 32.7166 8.12681 32.6746 8.11747C32.5346 8.0848 32.4132 8.20616 32.3292 8.31819C32.1425 8.57492 32.0118 8.85032 31.9044 9.14906C31.8111 9.40112 31.8718 9.71387 31.9791 9.96126C31.9931 9.99861 32.6933 8.99969 32.7773 8.17815Z",
    fill: "url(#paint0_linear_414_8918)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.827 21.9061L23.3294 25.6544L21.8311 23.3952L22.5966 21.7474L24.8651 20.207L29.827 21.9061Z",
    fill: "#26231F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74239 8.59351L2.47382 10.1339L2.40381 10.2833C1.9697 11.2168 2.04438 12.3091 2.59052 13.1773L3.15533 14.0689L9.70428 10.2879L4.73772 8.59351H4.74239Z",
    fill: "#26231F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7324 22.835C27.0976 22.4662 26.5188 22.4382 26.108 22.6856L24.6797 23.5118L27.9332 29.0759L29.3615 28.2496C29.7676 28.0069 30.015 27.5028 30.015 26.7839C30.015 25.3323 28.9928 23.5631 27.7371 22.835H27.7324Z",
    fill: "#26231F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5861 27.6056C28.5861 29.0573 27.5638 29.6501 26.3082 28.9219C25.0525 28.1937 24.0303 26.4293 24.0303 24.9729C24.0303 23.5165 25.0525 22.9284 26.3082 23.6566C27.5638 24.3848 28.5861 26.1492 28.5861 27.6056Z",
    fill: "#3F3932"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3036 28.1658C25.4354 27.685 24.7212 26.476 24.7072 25.4631C24.6932 24.4502 25.3841 24.0161 26.2523 24.4969C27.1205 24.9776 27.8347 26.1866 27.8487 27.1995C27.8627 28.2124 27.1719 28.6466 26.3036 28.1658Z",
    fill: "#D8D8D8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2993 27.9092C25.5525 27.4984 24.9363 26.4575 24.927 25.5846C24.913 24.7117 25.5058 24.3429 26.2527 24.7537C26.9995 25.1645 27.6157 26.2054 27.625 27.0783C27.639 27.9512 27.0462 28.3199 26.2993 27.9092Z",
    fill: "#A8A8A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3649 27.1808C25.9448 26.9475 25.5947 26.3593 25.59 25.8692C25.5807 25.3744 25.9168 25.1643 26.3416 25.3977C26.7663 25.6311 27.1117 26.2193 27.1164 26.7094C27.1257 27.2042 26.7897 27.4142 26.3649 27.1808Z",
    fill: "#D8D8D8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1906 25.8459C27.0039 25.5145 26.7425 25.2204 26.4484 25.0617C25.8976 24.7583 25.4635 25.0337 25.4728 25.6732C25.4821 26.3127 25.9349 27.0829 26.4857 27.3863C27.0132 27.6757 27.438 27.4376 27.4613 26.8495C27.4613 26.8261 27.4613 26.7981 27.4613 26.7748C27.4613 26.4714 27.3539 26.1446 27.1906 25.8506V25.8459ZM27.1112 26.7701C27.0925 27.2182 26.7658 27.4049 26.3644 27.1809C25.9443 26.9475 25.5942 26.3593 25.5895 25.8692C25.5802 25.3744 25.9162 25.1644 26.341 25.3978C26.5651 25.5191 26.7658 25.7432 26.9105 25.9999C26.9758 26.112 27.0225 26.2333 27.0599 26.3547C27.0972 26.476 27.1159 26.5974 27.1159 26.7141C27.1159 26.7328 27.1159 26.7514 27.1159 26.7748L27.1112 26.7701Z",
    fill: "#BEBEBE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74905 11.2964C7.11422 10.9276 6.53541 10.8996 6.12464 11.147L4.69629 11.9732L7.94976 17.5373L9.37812 16.7111C9.78422 16.4683 10.0316 15.9642 10.0316 15.2454C10.0316 13.7937 9.00936 12.0246 7.75371 11.2964H7.74905Z",
    fill: "#26231F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60267 16.0716C8.60267 17.5233 7.58042 18.1161 6.32477 17.3879C5.06913 16.6598 4.04688 14.8953 4.04688 13.439C4.04688 11.9826 5.06913 11.3945 6.32477 12.1226C7.58042 12.8508 8.60267 14.6153 8.60267 16.0716Z",
    fill: "#3F3932"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32024 16.6316C5.45202 16.1508 4.73785 14.9418 4.72384 13.9289C4.70984 12.916 5.40068 12.4819 6.26889 12.9627C7.13711 13.4435 7.85128 14.6524 7.86529 15.6654C7.87929 16.6783 7.18845 17.1124 6.32024 16.6316Z",
    fill: "#D8D8D8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31581 16.375C5.56896 15.9642 4.9528 14.9233 4.94347 14.0504C4.93413 13.1775 5.52228 12.8088 6.26913 13.2195C7.01598 13.6303 7.63214 14.6712 7.64147 15.5441C7.65548 16.417 7.06266 16.7857 6.31581 16.375Z",
    fill: "#A8A8A8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38038 15.642C5.96027 15.4086 5.61019 14.8205 5.60552 14.3303C5.60085 13.8402 5.93226 13.6255 6.35704 13.8589C6.77714 14.0923 7.12723 14.6804 7.1319 15.1705C7.14123 15.6607 6.80515 15.8754 6.38038 15.642Z",
    fill: "#D8D8D8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20716 14.3071C7.02045 13.9757 6.75905 13.6816 6.46498 13.5229C5.91418 13.2195 5.48007 13.4949 5.48941 14.1344C5.49874 14.7739 5.95152 15.544 6.50232 15.8475C7.02979 16.1369 7.45456 15.8988 7.4779 15.3107C7.4779 15.2873 7.4779 15.2593 7.4779 15.236C7.4779 14.9326 7.37054 14.6058 7.20716 14.3117V14.3071ZM7.12781 15.2313C7.10914 15.6794 6.78239 15.8661 6.38096 15.6421C5.96086 15.4087 5.61077 14.8205 5.6061 14.3304C5.60143 13.8403 5.93285 13.6256 6.35762 13.859C6.58168 13.9803 6.78239 14.2044 6.9271 14.4611C6.99245 14.5731 7.03912 14.6945 7.07647 14.8159C7.11381 14.9372 7.13248 15.0586 7.13248 15.1753C7.13248 15.194 7.13248 15.2126 7.13248 15.236L7.12781 15.2313Z",
    fill: "#BEBEBE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7488 17.3457C41.0253 16.2255 39.6623 14.9885 38.5514 14.251C35.4146 12.1551 34.1029 10.9928 31.2556 8.57023C30.266 7.72535 28.4735 6.01226 27.4326 5.2374C26.9892 4.91065 20.8977 1.27442 18.3117 0.252164C18.3117 0.294175 12.3135 0.686272 12.3135 0.686272L10.171 0.0374444C10.171 0.0374444 9.80691 -0.116594 9.24677 0.19615C7.94912 0.914995 2.57645 4.04244 1.21811 4.83597C0.984721 4.97133 0.784005 5.15338 0.639302 5.37744C0.559949 5.4988 0.485264 5.6295 0.457257 5.74153C0.354565 6.13362 0.186523 6.55373 0.186523 6.88514V10.7921C0.186523 11.1002 0.265876 11.4036 0.415247 11.6743C0.667309 12.1178 2.58579 13.6442 3.15526 14.0736C3.1646 11.7677 3.91145 10.3347 6.12866 11.6183C8.22919 12.832 9.10674 15.2265 9.10674 17.5558L23.3296 25.6638C23.3529 23.3952 24.0998 21.9949 26.303 23.2645C28.3568 24.4502 29.2344 26.7561 29.2764 29.034C30.0606 29.4727 29.6685 29.23 29.9346 29.3654C30.6814 29.7435 31.4843 29.9582 32.3012 29.9629C35.1299 29.9862 37.3517 28.8099 39.4103 27.4656C40.9133 26.4853 42.0802 25.4818 42.6497 24.5855C42.8971 24.1934 43.0045 23.7267 42.9951 23.2645C42.9718 22.0322 42.9625 19.2315 41.7442 17.3504L41.7488 17.3457Z",
    fill: "#0080CF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2,
    d: "M3.31885 12.5333C3.21149 12.9721 3.16481 13.4949 3.16014 14.069C2.586 13.6442 0.672192 12.1178 0.42013 11.6697C0.266091 11.399 0.191406 11.1003 0.191406 10.7875V10.7222L3.31885 12.5286V12.5333ZM8.93424 15.7774C9.0556 16.3609 9.11162 16.9584 9.11162 17.5512L23.3345 25.6592C23.3391 25.1037 23.3905 24.6043 23.4932 24.1795L8.93891 15.7774H8.93424Z",
    fill: "url(#paint1_linear_414_8918)"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.35 24.8843C42.5754 22.8865 42.8742 20.9167 42.8508 20.7533C42.7015 19.605 42.3981 18.3447 41.7492 17.3458C41.0257 16.2255 39.6627 14.9885 38.5518 14.251C35.415 12.1551 34.1033 10.9929 31.256 8.57026C30.2664 7.72538 28.4739 6.01229 27.433 5.23743C26.9896 4.91069 19.1756 0.485588 18.3121 0.252197C17.2712 0.578945 12.7574 2.9642 9.84465 4.84067C9.66728 4.95736 9.69528 5.2281 9.89133 5.30278C12.4773 6.30637 18.0554 9.52716 18.9749 10.6381C20.1045 12.0104 23.9415 18.074 23.9415 18.074C25.2625 19.423 28.2966 22.0603 29.6689 23.3533C31.2046 24.889 31.1113 25.4631 31.2466 26.6534C31.27 26.8541 31.4193 27.0175 31.6154 27.0502C33.8326 27.4143 36.3206 26.8635 39.35 24.875V24.8843Z",
    fill: "#1F8FD3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3115 0.252197C17.2706 0.578945 12.7568 2.9642 9.84408 4.84067C9.6667 4.95736 9.69937 5.21409 9.89076 5.30278C12.094 6.34371 16.2717 8.63561 18.2042 9.99395C18.3955 10.1293 21.3176 8.97169 23.6422 7.6367C25.696 6.45574 27.2084 5.08806 27.1337 5.03672C25.794 4.13583 19.3991 0.368893 18.3162 0.252197H18.3115Z",
    fill: "#12AAFF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M31.522 24.0674C37.282 24.5061 42.5894 19.6329 41.9732 17.7191C41.9032 17.5884 41.8332 17.4624 41.7538 17.341C41.0303 16.2208 39.6673 14.9838 38.5564 14.2463C37.1 13.2754 36.0404 12.5052 35.0368 11.7163C31.0552 17.0423 23.9414 18.0739 23.9414 18.0739C24.9403 19.0915 28.0678 21.8968 29.5288 23.2038C30.0843 23.6986 30.7844 24.0067 31.5266 24.0627L31.522 24.0674Z",
    fill: "url(#paint2_linear_414_8918)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35047 7.66946C8.32713 7.66013 8.30379 7.6788 8.28979 7.70214C7.84635 8.62637 7.96304 12.0152 7.86035 13.1915C7.89303 13.2382 7.95371 13.3269 7.95371 13.3269C8.0564 12.1786 8.00039 8.58902 8.38782 7.72548C8.39715 7.70214 8.37848 7.67413 8.35514 7.66479L8.35047 7.66946Z",
    fill: "#2A87BC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9449 20.3098L22.667 16.865C22.639 16.8837 22.611 16.8977 22.583 16.9117L24.8562 20.3519V22.7791C24.8889 22.7791 24.9216 22.7791 24.9543 22.7791V20.3332C24.9543 20.3332 24.9543 20.3145 24.9449 20.3052V20.3098Z",
    fill: "#2A87BC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.474 12.9859C15.446 12.9672 15.4133 12.9532 15.3807 12.9346C15.1986 14.853 15.0306 17.3783 15.0306 20.2491L9.0791 16.8135C9.0791 16.8509 9.08377 16.8929 9.08844 16.9302L15.0586 20.3751L23.3533 25.1643C23.3533 25.1269 23.358 25.0943 23.3626 25.0569L15.1333 20.3051C15.1333 17.4297 15.2966 14.9044 15.4787 12.9859H15.474Z",
    fill: "#2A87BC"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4529 17.5791C29.3282 16.795 32.1149 15.0165 34.4862 12.7666C34.7569 12.5099 34.7429 12.0758 34.4582 11.8331L27.1717 5.53149C25.5006 7.0532 22.77 8.56558 19.3018 10.0733C21.0335 13.0234 23.064 15.8334 24.6324 17.2057C25.2252 17.7239 25.7434 17.7659 26.4482 17.5745L26.4529 17.5791Z",
    fill: "#282523"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0658 16.4448C24.9865 16.4448 24.9071 16.4448 24.8277 16.4308C24.2723 16.3701 23.8335 15.964 23.4834 15.5299C22.5919 14.4143 20.7014 11.9964 19.9032 10.652C19.8192 10.512 19.8798 10.33 20.0339 10.2599C23.2687 8.82692 25.6026 7.48725 27.143 6.18493C27.2643 6.08224 27.4417 6.08224 27.5631 6.18493L33.2438 11.1235C33.3419 11.2075 33.3979 11.3242 33.3979 11.4549C33.3979 11.5809 33.3512 11.6976 33.2625 11.7817C30.7325 14.1762 28.3053 15.6373 25.6166 16.3701C25.4392 16.4168 25.2525 16.4448 25.0705 16.4448H25.0658Z",
    fill: "#35312D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0303 11.343C18.6475 10.7595 18.1387 10.2741 17.5366 9.92865C15.198 8.57032 12.318 6.85256 10.4088 5.92366C10.2034 5.82563 9.97471 5.79763 9.75066 5.84897C8.50902 6.13838 5.45626 7.65542 6.07241 8.01018C8.01423 9.13045 20.7247 16.3936 22.6712 17.4532C22.7926 17.5185 22.9466 17.3878 22.8766 17.2711C22.3211 16.3376 20.1039 12.9627 19.035 11.343H19.0303Z",
    fill: "#282523"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85473 6.32983C7.72511 6.80595 6.3201 7.56681 6.31543 7.84688C6.65151 8.03826 7.23966 8.37901 8.00051 8.81312C8.0752 8.37901 8.28992 7.44544 8.85473 6.32983Z",
    fill: "#35312D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20584 8.93438C10.0356 9.97998 12.743 11.5297 15.3383 13.0047C15.413 12.3559 15.6323 10.7782 16.1785 9.28914C14.148 8.10351 11.8701 6.77785 10.3017 6.02166C10.157 5.95164 9.99362 5.93764 9.83491 5.97498C9.65287 6.02166 9.42414 6.10101 9.17208 6.19904C8.49058 7.46402 8.26652 8.53762 8.20117 8.92972L8.20584 8.93438Z",
    fill: "#35312D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.919 11.4132C18.5456 10.8484 18.0461 10.3722 17.4673 10.0408L16.375 9.40601C15.8149 10.9417 15.6095 12.5661 15.5488 13.1263C18.7556 14.9514 21.743 16.6458 22.6019 17.1126H22.6299C22.0651 16.165 19.8852 12.8742 18.919 11.4132Z",
    fill: "#35312D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1991 24.1327C36.3345 24.5808 36.7966 25.6404 37.0953 25.5751C38.4303 25.2903 41.0957 23.3439 41.4831 22.6017C41.6185 22.3403 41.1143 20.7112 40.9556 20.6692C40.3582 21.3507 39.4946 22.1256 38.561 22.7044C37.3614 23.4512 36.1431 23.9367 36.1991 24.1327Z",
    fill: "#007AC5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5614 22.7045C37.8799 23.1293 37.1844 23.4514 36.727 23.6848C36.3769 23.8622 36.1622 23.9742 36.1995 24.1329C36.2882 24.511 36.6476 25.2858 36.9277 25.5099C38.2674 25.2112 40.9093 23.2833 41.2921 22.5412C41.4041 22.3264 41.0774 21.1688 40.872 20.7581C40.2792 21.4162 39.453 22.1537 38.5568 22.7092L38.5614 22.7045Z",
    fill: "#35312D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6055 17.9851C29.1599 20.207 32.0772 21.8221 34.4952 22.6856C32.1939 21.8221 29.3419 19.7495 27.6055 17.9851Z",
    fill: "#1F8FD3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M34.873 13.7048C36.6842 14.9371 39.4102 17.2991 40.3437 19.2455C40.003 17.8079 37.6737 15.1939 34.873 13.7048Z",
    fill: "url(#paint3_linear_414_8918)"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M17.248 15.7587L16.0157 15.0492C15.9457 15.0072 15.8896 14.9185 15.8896 14.8485V14.6758C15.8896 14.6058 15.9457 14.5824 16.0157 14.6244L17.248 15.3339C17.318 15.376 17.374 15.4646 17.374 15.5347V15.7074C17.374 15.7774 17.318 15.8007 17.248 15.7587Z",
    fill: "#1F8FD3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88666 11.5063L8.65435 10.7968C8.58433 10.7548 8.52832 10.6661 8.52832 10.5961V10.4233C8.52832 10.3533 8.58433 10.33 8.65435 10.372L9.88666 11.0815C9.95667 11.1235 10.0127 11.2122 10.0127 11.2822V11.4549C10.0127 11.5249 9.95667 11.5483 9.88666 11.5063Z",
    fill: "#1F8FD3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9894 15.9688C18.7886 16.1975 18.98 16.9117 19.3021 17.0611C19.3628 17.0891 19.4328 17.0984 19.5028 17.1031C20.175 17.1778 21.0899 17.1871 21.4166 16.8137C21.5146 16.7017 21.5053 16.6316 21.4586 16.4963C21.3933 16.2956 21.1646 15.4413 20.9918 15.348C20.8378 15.2686 19.106 15.8288 18.9894 15.9641V15.9688Z",
    fill: "#1F8FD3"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M21.2723 15.9034C21.1836 15.6467 21.0809 15.3993 20.9922 15.3526C20.8382 15.2733 19.1064 15.8334 18.9897 15.9688C18.9524 16.0155 18.929 16.0808 18.915 16.1555C19.8019 16.2862 20.8195 16.1275 21.2723 15.8988V15.9034Z",
    fill: "url(#paint4_linear_414_8918)"
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1631 16.5382C22.1024 16.5289 21.5283 16.3935 21.4256 16.3795C21.0848 16.3328 20.6087 16.9396 20.7487 17.1077C20.7861 17.1544 22.2611 17.2477 22.3078 17.2477C22.5459 17.2664 22.4805 16.5756 22.1631 16.5335V16.5382Z",
    fill: "#282523"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1.49807 10.5914L1.06396 10.3394C0.998612 10.302 0.947266 10.2227 0.947266 10.1573V10.106C0.947266 10.0406 0.998612 10.022 1.06396 10.0593L1.49807 10.3114C1.56342 10.3487 1.61476 10.4281 1.61476 10.4934V10.5448C1.61476 10.6101 1.56342 10.6288 1.49807 10.5914Z",
    fill: "#CB5E12"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8115 22.8959L22.3774 22.6438C22.3121 22.6065 22.2607 22.5271 22.2607 22.4618V22.4104C22.2607 22.3451 22.3121 22.3264 22.3774 22.3638L22.8115 22.6158C22.8769 22.6532 22.9282 22.7325 22.9282 22.7979V22.8492C22.9282 22.9146 22.8769 22.9332 22.8115 22.8959Z",
    fill: "#CB5E12"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0.261844 6.39505C0.261844 6.39505 -0.279623 7.44064 0.191827 8.84099C0.523243 8.91567 0.644606 7.50132 0.677281 6.94118C0.686616 6.80115 0.621267 6.67045 0.504571 6.5911L0.261844 6.39038V6.39505Z",
    fill: "#991111"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0371 24.4873C35.5599 24.422 36.1761 25.883 35.6066 26.2051C35.0465 26.5225 33.5901 26.8913 31.611 26.6672C30.7614 26.3918 30.57 24.688 31.4663 24.604C32.0917 24.6367 33.044 24.7301 35.0371 24.4827V24.4873Z",
    fill: "#F0FDFF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M31.466 24.6041C30.103 24.5294 30.6725 26.5645 31.6107 26.6672C31.3073 26.2891 31.0506 24.9868 31.466 24.6041Z",
    fill: "#CB5E12"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6467 20.0857C41.5813 20.4731 41.8894 21.6961 42.0388 21.7614C42.2208 21.8361 42.7809 20.7859 42.7763 20.2537C42.7763 19.7916 42.5289 18.704 42.2535 18.3259C42.0621 19.1755 41.6887 19.8523 41.6513 20.0904L41.6467 20.0857Z",
    fill: "#F0FDFF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7518 23.5166C38.8592 23.7594 39.1159 23.8574 39.326 23.736C39.536 23.6147 39.6247 23.3159 39.5173 23.0732C39.41 22.8305 39.1533 22.7325 38.9432 22.8538C38.7331 22.9752 38.6445 23.2739 38.7518 23.5166Z",
    fill: "#4C4742"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0912 24.6042L38.1738 26.5601V27.6103L41.0912 25.6545V24.6042Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9404 1.09716L4.0798 5.63429C3.58968 5.97504 4.77064 5.77432 6.14298 5.56894C7.32394 5.39156 8.61226 5.1535 8.61226 5.1535C8.86432 5.10682 9.49448 4.78941 9.71386 4.65404C12.5239 2.96896 15.2779 1.40524 17.2011 0.551025L12.7666 0.868437C12.4772 0.868437 12.1925 0.943123 11.9404 1.08783V1.09716Z",
    fill: "#282523"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15529 5.97025L12.3089 0.686272L10.171 0.0374444C10.171 0.0374444 9.81161 -0.116594 9.2468 0.19615C7.94915 0.914995 2.57648 4.04244 1.21815 4.83597C0.984754 4.97133 0.784038 5.15338 0.639335 5.37744C0.629999 5.39144 0.620664 5.41011 0.611328 5.42411C1.61958 5.76953 3.15062 5.97025 3.15062 5.97025H3.15529Z",
    fill: "#12AAFF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0215 29.3933C33.3565 29.552 34.5141 29.2953 35.0229 29.0993C35.2376 29.0152 35.1723 28.7492 35.1583 28.5111C35.1489 28.4038 35.0649 28.3244 34.9575 28.3291C34.4627 28.3524 33.4965 28.4271 32.0775 27.965C31.9328 27.9183 31.7881 28.021 31.7881 28.1704V29.0993C31.7881 29.2393 31.8861 29.3747 32.0261 29.3887L32.0215 29.3933Z",
    fill: "#35312D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9351 21.6167C42.9258 21.7988 42.8884 22.1722 42.7391 22.8117C42.7111 22.9377 42.6924 23.0684 42.6924 23.1945C42.6924 23.3625 42.6924 23.7359 42.6924 23.932C42.6924 24.0067 42.7297 24.002 42.7437 23.9693C42.8651 23.7639 42.9584 23.4932 42.9958 23.3018C42.9958 23.2831 42.9958 23.2691 42.9958 23.2505C42.9865 22.8444 42.9818 22.2656 42.9304 21.6121L42.9351 21.6167Z",
    fill: "#35312D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_414_8918",
    x1: 31.8624,
    y1: 9.03237,
    x2: 32.7773,
    y2: 9.03237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23A8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#4AA1D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#2485C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23A8FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_414_8918",
    x1: 12.099,
    y1: 17.6025,
    x2: 11.3755,
    y2: 18.8582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23A8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0B7DC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0A649B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#04588B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#0A71B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C517C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_414_8918",
    x1: 31.1579,
    y1: 15.936,
    x2: 37.9029,
    y2: 22.5037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#0B95C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_414_8918",
    x1: 34.873,
    y1: 16.4729,
    x2: 40.3437,
    y2: 16.4729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23A8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#23A8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#1A88CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#23A8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239BE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_414_8918",
    x1: 18.9197,
    y1: 15.7727,
    x2: 21.2723,
    y2: 15.7727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#18648F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557292,
    stopColor: "#219FC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25A0E5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_414_8918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 29.9581,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.00e249d5335b77d8fdbb72b32ba7a8aa.svg";
export { ForwardRef as ReactComponent };